import React from 'react';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Panel } from '@ktr/ktr-materialui-react';
//import Configuration from '../../config/Config';
import CoolerResult from '../CoolerResult/CoolerResult';
import { LayoutResult, LayoutInput } from '../../service/ServiceAPI';
import { RootState } from '../../store/Store';      // combined state of LayoutInputState and LayoutOutputState (because we use 2 combined reducers)

import { useTranslation } from 'react-i18next';
//import { orange } from '@material-ui/core/colors';


// ---------------------------------------------------
// ---------------------------------------------------
// CSS
// ---------------------------------------------------
const useStyles = makeStyles(theme => ({
    outputstyle: {
        //backgroundColor: theme.palette.background.paper,
        //backgroundColor: 'white',
        //color: 'darkgray',
        //border: '1px solid black',
        //padding: '10px',
        //marginLeft: '5px',
        //marginRight: '5px',
    },
  
}));
  

// ---------------------------------------------------
// ---------------------------------------------------
// Properties
// ---------------------------------------------------
type Props = {
    //title?: string
}

// we need two portions of properties to have interfaces/types for each redux-mapping-method (mapStateToProps/mapDispatchToProps)
type PropsStatic = {
    isInvalid: boolean,
    layoutInput: LayoutInput,
    layoutOutput?: LayoutResult[]
}

type PropsHandler = {
//    updateLayoutOutput(state: LayoutOutputState): any
}

// ---------------------------------------------------
// ---------------------------------------------------
// REDUX store
// ---------------------------------------------------

// Map component-properties to redux-store parts (input is the state, we return the according properties)
// this is the way from redux-store to component-properties
// retuns a state matching to given props
function mapStateToProps(state: RootState): PropsStatic {
  return {
    isInvalid: state.output.isInvalid,
    layoutInput: state.input.layoutInput,                 // combined state  
    layoutOutput: state.output.layoutOutput               // combined state  
  };
}


// Concatenate the two property-type-portions to a single property-type to be used in the component-creation
type OutputComponentProps = Props & PropsStatic & PropsHandler;


// ---------------------------------------------------
// ---------------------------------------------------
// Component
// ---------------------------------------------------
// stateless component resp. functional component
//function OutputComponent(props: OutputComponentProps) {
const OutputComponent = (props: OutputComponentProps) => {
    const classes = useStyles();

    //const { t, i18n } = useTranslation();
    const { t } = useTranslation();

    //
    function createContactMail(layoutInput: LayoutInput) {
        let strAdressTo: string = "hydraulic@ktr.com";
      
        let strSubject = t('contactmail.subject') + " " + layoutInput.phename;
      
        let strBody = t('contactmail.para1');
        let opstring = (layoutInput.operation === 'rate' ? t('operation_rating') : t('operation_performance'));
        strBody += ("  - " + t('inputdata.operation') + ": " + opstring + " \n");
        //strBody += ("  - " + t('inputdata.operation') + ": " + layoutInput.operation + " \n");
        strBody += ("  - " + t('inputdata.tempin1') + ": " + layoutInput.inTempSide1 + " °C\n");
        strBody += ("  - " + t('inputdata.tempin2') + ": " + layoutInput.inTempSide2 + " °C\n");
        strBody += ("  - " + t('inputdata.volumeflow1') + ": " + layoutInput.volumeFlowSide1 + " l/min\n");
        strBody += ("  - " + t('inputdata.volumeflow2') + ": " + layoutInput.volumeFlowSide2 + " l/min\n");
        strBody += ("  - " + t('inputdata.fluid1') + ": " + layoutInput.fluidSide1 + " \n");
        strBody += ("  - " + t('inputdata.fluid2') + ": " + layoutInput.fluidSide2 + " \n");
        strBody += ("  - " + t('inputdata.heatdissipation') + ": " + layoutInput.heatDissipation + " kW\n");

        strBody += "\n";
        strBody += t('contactmail.contact');
        strBody += t('contactmail.name');
        strBody += t('contactmail.adress');
        strBody += t('contactmail.mail');
        strBody += t('contactmail.phone');

        strBody += t('contactmail.footer');
        
        var strMailLink = "mailto:" + strAdressTo + "?subject=" + encodeURIComponent(strSubject) + "&body=" + encodeURIComponent(strBody);

        return strMailLink;
    }

    // ----
    var OutputStyle = { opacity: '1.0' };
    if(props.isInvalid === true) {
        //OutputStyle = { textDecoration: 'line-through', opacity: '0.6' };
        OutputStyle = { opacity: '0.6' };
    }

    if((props.layoutOutput === undefined) || (props.layoutOutput.length === 0)) {
        return (
            <Grid container className={classes.outputstyle} style={OutputStyle} >
                <Grid item xs={12}>
                    <h2>{t('titleoutput')}</h2>
                </Grid>
                <Grid item xs={12}>
                    <Panel title="">
                        {t('outputdata.nothingfound')}<br/>
                        T: <a style={{color: "orange"}} href='tel:+49 5971 798 0'> +49 5971 798 0</a>
                        <br/>
                        E: <a style={{color: "orange"}} href={createContactMail(props.layoutInput)}>hydraulic@ktr.com</a>
                    </Panel>
                </Grid>
            </Grid>
        );
    }
    else {
        // we create the list of <CoolerResult> components from the result list:
        let i = 0;
        //var listCoolerResultElement: JSX.Element[] = [];
        let listCoolerResultElement = new Array<JSX.Element>(3);

        props.layoutOutput.map(res => {
            let r: number = Number(res.ranking);
            if(Number.isNaN(r))
                return null;

            if(r === 0) {
                res.ranking = t('outputdata.bestfit');
                return listCoolerResultElement[0] = (<CoolerResult key={++i} inputdata={props.layoutInput} couplingdata={res} />);
            }
            else if(r === -1) {
                res.ranking = t('outputdata.nextsmaller');
                return listCoolerResultElement[1] = (<CoolerResult key={++i} inputdata={props.layoutInput} couplingdata={res} />);
            }
            else if(r === 1) {
                res.ranking = t('outputdata.nextlarger');
                return listCoolerResultElement[2] = (<CoolerResult key={++i} inputdata={props.layoutInput} couplingdata={res} />);
            }

            return listCoolerResultElement;
        });


        return (
            <Grid container className={classes.outputstyle} style={OutputStyle} >
                <Grid item xs={12}>
                    <h1>{t('titleoutput')}</h1>
                </Grid>
                <Grid item xs={12}>
                    {/*<Panel title="Matching cooler by rank">*/}
                        { listCoolerResultElement }
                    {/*</Panel>*/}
                </Grid>
            </Grid>
        );
    }

}

export default connect(mapStateToProps)(OutputComponent);
